import { useCallback, useEffect, useRef, useState } from 'react';

// One transient message at a time ("Link copied · votomoto.com/p/k7q2x").
export function useToast(durationMs = 2600) {
  const [message, setMessage] = useState('');
  const timer = useRef(null);
  const show = useCallback((text) => {
    setMessage(text);
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => { setMessage(''); timer.current = null; }, durationMs);
  }, [durationMs]);
  useEffect(() => () => { if (timer.current) clearTimeout(timer.current); }, []);
  return [message, show];
}

export default function Toast({ message, className = '' }) {
  return (
    <div aria-live="polite" role="status" className={className}>
      {message ? (
        <p className="rounded-xl bg-voto-chrome px-4 py-2.5 text-sm text-voto-fg ring-1 ring-voto-line">
          {message}
        </p>
      ) : null}
    </div>
  );
}
